import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as simulator from './simulator';
import * as tios from './tios';

export default class WiegandNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Wiegand';
        this.id = 'node_wiegand';
        this.icon = 'AiOutlineIdcard';
        this.linkedFeature = 'general';
        this.requirements = ['TPP'];
        this.outputs = [
            {
                name: 'Data Available',
                portId: 'data_available',
                params: [
                    {
                        name: 'wiegand_data',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'facility_code',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'card_code',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'id_code',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        const settings: Array<Setting> = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_08',
                default: '',
            },
            {
                id: 'FORMAT',
                name: 'Format',
                settingType: SettingType.OPTION,
                required: true,
                helpText: 'The card ID in your specified format.',
                default: 'binary',
                options: [
                    {
                        name: 'Binary',
                        value: 'binary',
                    },
                    {
                        name: 'Hex',
                        value: 'hex',
                    },
                    {
                        name: 'Decimal',
                        value: 'dec',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const TIBBIT = project.getFeature(this.getSettingValue('TIBBIT'));
            if (TIBBIT) {
                return `On {{$${TIBBIT.getSettingValue('NAME')}}} Wiegand`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const TIBBIT = project.getFeature(this.getSettingValue('TIBBIT'));
        if (TIBBIT) {
            return `On {{$${TIBBIT.getSettingValue('NAME')}}} Wiegand`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }

    getDetails(): string {
        return `
This block is triggered when the device receives a Wiegand input.`;
    }
}
